export default "__VITE_ASSET__C4tZaStM__"